module.exports = __webpack_public_path__ + "img/successfactor.8d29414c.jpg";